import {
  json as baseJson,
  info as baseInfo,
} from '../../Base/Signup_fortuneWheel'
import themeBase from './_themeBase'
import INDEX from './_index'
import { image } from '@components/Widgets/_contentItems/all'

const info = JSON.parse(JSON.stringify(baseInfo))
const json = JSON.parse(JSON.stringify(baseJson))
const templateID = info.templateID + INDEX

info.templateID = templateID
info.priority = 40
info.name = 'Black Friday: ' + info.name

json.templateID = templateID

// Apply theme-specific styling overrides
json.styling = {
  ...json.styling,
  backgroundColor: '#000000',
  backgroundImage: 'url("https://assets.onvocado.com/templates/black_friday-bg.jpg")',
}

json.theme = themeBase.theme

const customImage = (() => {
  const img = JSON.parse(JSON.stringify(image))
  img.content.url = 'https://assets.onvocado.com/templates/black_friday_tag.png'
  Object.assign(img.styling, {
    backgroundSize: 'cover',
    backgroundColor: 'rgba(0, 0, 0, 0)',
    backgroundPosition: 'center',
  })
  return img
})()

// Insert the customImage at the beginning of steps[0].contentItems
json.steps[0].contentItems.unshift(customImage)

// Modify content items as needed
json.steps[0].contentItems = json.steps[0].contentItems.map((item) => {
  if (item.type === 'headline') {
    item.content.text = 'Black Friday Specials Await!'
    item.styling.fontSize = '40px'
  }
  return item
})

json.steps[1].contentItems.unshift(customImage)

export { json, info }
